export default {
    /**
     * 设置本地存储
     * 如果name是数组 value必须是数组
     * @param {*} name type Array<string> | string
     * @param {*} value type Array<any> | any 转字符串在这里执行
     */
    setLocal(name, value) {
        if (Object.prototype.toString.call(name) == "[object Array]") {
            for (let i = 0, length = name.length; i < length; i++) {
                let data = "";
                if (value[i] && typeof value[i] == "object") {
                    data = JSON.stringify(value[i]);
                    localStorage.setItem(name[i], data);
                };
            }
        } else {
            if (value && typeof value == "object") value = JSON.stringify(value);
            localStorage.setItem(name, value);
        }
    },
    /**
     * 获取本地存储
     * @param {*} name 要获取的名字
     * @param {*} type 如果是对象传object 返回转码后的对象
     */
    getLocal(name, type) {
        let data = localStorage.getItem(name);
        if (type == "object" && data) return JSON.parse(data);
        else return data;
    },
    /**
     * 要删除的存储 可以删多个传数组 或删一个传字符串
     * @param {*} name type Array<string> | string
     */
    removeLocal(name) {
        if (name && typeof name == "object") {
            for (let i = 0, length = name.length; i < length; i++) {
                //console.log(name[i]);
                localStorage.removeItem(name[i]);
            }
        } else {
            localStorage.removeItem(name);
        }

    },
    /**
     * 获取权限
     */
    getRole() {
       return this.getLocal("role", "object");
    }
}